<template>
  <div>
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item href="#">CRM管理</Breadcrumb-item>
        <Breadcrumb-item>销售话术库</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div style="margin-top: 10px">
      <Form :label-width="85" :show-message="false">
        <Row :gutter="32">
          <Col span="6">
            <Form-item label="场景">
              <Select v-model="queryParam.scene" clearable placeholder="全部">
                <Option v-for="opt in sceneOptions" :key="opt.value" :value="opt.value">{{ opt.label }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col span="6">
            <Form-item label="状态">
              <Select v-model="queryParam.status" clearable placeholder="全部">
                <Option :value="0">候选</Option>
                <Option :value="1">已发布</Option>
                <Option :value="2">停用</Option>
              </Select>
            </Form-item>
          </Col>
          <Col span="6">
            <Form-item label="话术">
              <Input placeholder="关键字" v-model="queryParam.phrase"/>
            </Form-item>
          </Col>
          <Col span="6">
            <Button type="primary" :loading="searchLoading" icon="search" @click="search">搜索</Button>
            <Button type="success" style="margin-left: 8px" @click="openCreate">新增</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <List ref="list" style="margin-top: 10px" :tableColumns="tableColumns" listUrl="/callScript/page-list"
          :params="queryParam" :onLoading="onLoading" :reload="reload"></List>
    <Modal v-model="editVisible" :title="form.id ? '编辑话术' : '新增话术'" width="560">
      <Form :label-width="90">
        <Form-item label="场景">
          <Select v-model="form.scene">
            <Option v-for="opt in sceneOptions" :key="opt.value" :value="opt.value">{{ opt.label }}</Option>
          </Select>
        </Form-item>
        <Form-item label="话术">
          <Input v-model="form.phrase" type="textarea" :rows="4" placeholder="给销售复用的标准句"></Input>
        </Form-item>
        <Form-item v-if="form.id" label="状态">
          <Select v-model="form.status">
            <Option :value="0">候选</Option>
            <Option :value="1">已发布</Option>
            <Option :value="2">停用</Option>
          </Select>
        </Form-item>
      </Form>
      <div slot="footer">
        <Button @click="editVisible = false">取消</Button>
        <Button type="primary" @click="save">保存</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: 'CallScript',
  data () {
    return {
      searchLoading: false,
      reload: 0,
      editVisible: false,
      queryParam: {
        scene: '',
        status: '',
        phrase: ''
      },
      form: {},
      sceneOptions: [
        { value: 'OPENING', label: '开场' },
        { value: 'OBJECTION', label: '异议' },
        { value: 'INVITE_TRIAL', label: '邀约体验' },
        { value: 'CLOSE', label: '促单' },
        { value: 'FOLLOWUP', label: '回访' }
      ],
      tableColumns: [
        { title: 'ID', key: 'id', width: 80 },
        {
          title: '场景',
          key: 'scene',
          width: 110,
          render: (h, params) => h('span', this.sceneLabel(params.row.scene))
        },
        { title: '话术', key: 'phrase', minWidth: 280 },
        {
          title: '状态',
          key: 'status',
          width: 90,
          render: (h, params) => h('span', this.statusLabel(params.row.status))
        },
        { title: '来源通话', key: 'sourceCallId', width: 100 },
        { title: '修改时间', key: 'gmtModified', minWidth: 170 },
        {
          title: '操作',
          key: 'action',
          width: 240,
          render: (h, params) => {
            const btns = [
              h('Button', {
                props: { type: 'primary', size: 'small' },
                style: { marginRight: '6px' },
                on: { click: () => this.copyPhrase(params.row.phrase) }
              }, '复制'),
              h('Button', {
                props: { size: 'small' },
                style: { marginRight: '6px' },
                on: { click: () => this.openEdit(params.row) }
              }, '编辑')
            ]
            if (params.row.status !== 1) {
              btns.push(h('Button', {
                props: { size: 'small' },
                on: { click: () => this.changeStatus(params.row.id, 1) }
              }, '发布'))
            } else {
              btns.push(h('Button', {
                props: { size: 'small' },
                on: { click: () => this.changeStatus(params.row.id, 2) }
              }, '停用'))
            }
            return h('div', { style: { whiteSpace: 'nowrap' } }, btns)
          }
        }
      ]
    }
  },
  methods: {
    onLoading (loading) {
      this.searchLoading = loading
    },
    sceneLabel (code) {
      const hit = this.sceneOptions.find(item => item.value === code)
      return hit ? hit.label : (code || '')
    },
    statusLabel (code) {
      if (code === 0) return '候选'
      if (code === 1) return '已发布'
      if (code === 2) return '停用'
      return ''
    },
    emptyForm () {
      return {
        scene: 'OPENING',
        phrase: '',
        status: 1
      }
    },
    search () {
      this.reload = Date.now()
      this.$nextTick(() => this.$refs.list && this.$refs.list.search())
    },
    openCreate () {
      this.form = this.emptyForm()
      this.editVisible = true
    },
    openEdit (row) {
      this.form = {
        id: row.id,
        scene: row.scene,
        phrase: row.phrase,
        status: row.status
      }
      this.editVisible = true
    },
    save () {
      this.$http.post('/callScript/save', this.form).then(res => {
        if (res.status === 'ok') {
          this.$Message.success(this.form.id ? '已更新' : '已新建')
          this.editVisible = false
          this.search()
        } else {
          this.$Message.error(res.msg || '保存失败')
        }
      })
    },
    changeStatus (id, status) {
      this.$http.post('/callScript/status', { id: id, status: status }).then(res => {
        if (res.status === 'ok') {
          this.$Message.success(status === 1 ? '已发布' : '已停用')
          this.search()
        } else {
          this.$Message.error(res.msg || '操作失败')
        }
      })
    },
    copyPhrase (text) {
      if (!text) {
        return
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(() => {
          this.$Message.success('已复制')
        }).catch(() => {
          this.fallbackCopy(text)
        })
      } else {
        this.fallbackCopy(text)
      }
    },
    fallbackCopy (text) {
      const input = document.createElement('textarea')
      input.value = text
      document.body.appendChild(input)
      input.select()
      try {
        document.execCommand('copy')
        this.$Message.success('已复制')
      } catch (e) {
        this.$Message.error('复制失败')
      }
      document.body.removeChild(input)
    }
  }
}
</script>



// WEBPACK FOOTER //
// CallScript.vue?5946b794